import React from "react";
import clsx from "clsx";
import { Icon, IconName } from "halifax";
import styles from "./styles.module.scss";

const steps = new Array(5).fill(0).map((_, index) => ({
  value: index + 1,
  label: `Step ${index + 1}`,
}));

interface MobileBookingStepsProps {
  currentStep: 1 | 2 | 3 | 4 | 5;
}

export const MobileBookingSteps: React.FC<MobileBookingStepsProps> = ({
  currentStep,
}) => (
  <div className={styles["mobile-package-booking-steps-root"]}>
    {steps.map((step) => (
      <React.Fragment key={step.label}>
        <div
          className={clsx(styles.step, {
            [styles.active]: currentStep === step.value,
            [styles.complete]: currentStep > step.value,
          })}
        >
          {currentStep > step.value ? (
            <Icon name={IconName.CheckMark} />
          ) : (
            step.label
          )}
        </div>
        {step.value < steps.length && <div className={styles.separator} />}
      </React.Fragment>
    ))}
  </div>
);
